import { render, staticRenderFns } from "./AdditionalDepartureRequiredCard.vue?vue&type=template&id=45ce3ad6&scoped=true&"
import script from "./AdditionalDepartureRequiredCard.vue?vue&type=script&lang=js&"
export * from "./AdditionalDepartureRequiredCard.vue?vue&type=script&lang=js&"
import style0 from "./AdditionalDepartureRequiredCard.vue?vue&type=style&index=0&id=45ce3ad6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45ce3ad6",
  null
  
)

export default component.exports
import {QCard,QCardSection,QItem,QInput,QIcon,QSeparator,QCardActions,QBtn} from 'quasar'
component.options.components = Object.assign({QCard,QCardSection,QItem,QInput,QIcon,QSeparator,QCardActions,QBtn}, component.options.components || {})
